Histoire = {

	init : ->
		console.log "Histoire init"
		@sliderManager()

	sliderManager : ->

		_this = @

		sliderContainer = $('.block-histoire .slider-container')
		slider = $('.histoire--slider')
		slidesCount = slider.find('.histoire--slide').length 
		
		@updateControls()
		
		sliderContainer.find('.control').on "click", (ev) ->
			currentSlide = slider.find('.histoire--slide.selected')
			
			if $(@).hasClass('control_prev')
				
				prevSlideIndex = currentSlide.index() - 1
				prevSlide = slider.find('.histoire--slide:eq('+prevSlideIndex+')')

				tlPrevSlide = new TimelineLite
					
				tlPrevSlide.staggerTo [
					currentSlide.find('.slide--img'),
					currentSlide.find('.slide--date'),
					currentSlide.find('.slide--txt')
				], 0.6, {y:20, autoAlpha:0, ease:Quint.easeIn}, 0.08
				tlPrevSlide.add ->
					# Switch selected
					currentSlide.removeClass('selected')
					prevSlide.addClass('selected')
					_this.updateControls()
				tlPrevSlide.staggerFromTo [
					prevSlide.find('.slide--img'),
					prevSlide.find('.slide--date'),
					prevSlide.find('.slide--txt')
				], 0.6, {y:-20, autoAlpha:0}, {y:0, autoAlpha:1, ease:Quint.easeOut}, 0.08
			
			else if $(@).hasClass('control_next')
				
				nextSlideIndex = currentSlide.index() + 1
				nextSlide = slider.find('.histoire--slide:eq('+nextSlideIndex+')')

				tlNextSlide = new TimelineLite
				tlNextSlide.staggerTo [
					currentSlide.find('.slide--img'),
					currentSlide.find('.slide--date'),
					currentSlide.find('.slide--txt')
				], 0.6, {y:-20, autoAlpha:0, ease:Quint.easeIn}, 0.08
				tlNextSlide.add ->
					# Switch selected
					currentSlide.removeClass('selected')
					nextSlide.addClass('selected')
					_this.updateControls()
				tlNextSlide.staggerFromTo [
					nextSlide.find('.slide--img'),
					nextSlide.find('.slide--date'),
					nextSlide.find('.slide--txt')
				], 0.6, {y:20, autoAlpha:0}, {y:0, autoAlpha:1, ease:Quint.easeOut}, 0.08


	updateControls : ->
		# Init slider : hide prev or next arrows if first or last slide
		selectedSlideIndex = $('.histoire--slide.selected').index()
		
		if selectedSlideIndex == 0
			TweenLite.to $('.block-histoire .slider-container .control_prev'), 0.3, {autoAlpha:0}
		else if selectedSlideIndex == $('.histoire--slide').length - 1
			TweenLite.to $('.block-histoire .slider-container .control_next'), 0.3, {autoAlpha:0}
		else
			TweenLite.to $('.block-histoire .slider-container .control'), 0.3, {autoAlpha:1}

	destroy : ->
		console.log "Histoire destroy"
}